import { render } from "./PopUpWithButton.vue?vue&type=template&id=b7e5e046&scoped=true&ts=true&lang=pug"
import script from "./PopUpWithButton.vue?vue&type=script&lang=ts"
export * from "./PopUpWithButton.vue?vue&type=script&lang=ts"

import "./PopUpWithButton.vue?vue&type=style&index=0&id=b7e5e046&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e5e046"]])

export default __exports__